module.exports = __webpack_public_path__ + "img/logo_trace1.c602ec15.png";